import React, { useState } from "react";
import "./App.css";

function App() {
    // Khai báo state cho username và password
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    return (
        <div className="App" >
            <header style={{ background: "red", padding: 20 }} className="App-header">
                <h1>Username/Password</h1>

                <input
                    style={{ borderWidth: 10, borderColor: "blue" }}
                    type="text"
                    placeholder="Enter the Username"
                    onChange={(event) => setUsername(event.target.value)}
                />

                <input
                    style={{ borderWidth: 10, borderColor: "blue", marginTop: 10 }}
                    type="password"
                    placeholder="Enter the Password"
                    onChange={(event) => setPassword(event.target.value)}
                />

                <button
                    style={{ padding: 8, marginTop: 10 }}
                    onClick={() =>{
                        if(username === "" || password === "" ){
                        alert("Please enter a username and password");
                     }else {
                            alert(username + " - " + password)
                        }
                }}> Submit</button>
            </header>



        </div>
    );
}

export default App;
